module.exports = __webpack_public_path__ + "static/media/how-it-works-step-1-residential.93113a72.jpg";